/* eslint-disable */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import queryString from 'query-string';

import { Box, Button, FormControl } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';

import PageInfo from 'components/PageInfo';
import MenuInfo from 'data/menu';
import CustomSelect from 'components/select/CustomSelect';
import { fromServerFormat, nowFormat } from 'components/date_picker/dateUtils';
import CustomDatePicker from 'components/date_picker/CustomDatePicker';
import { getAccessLogs } from 'components/axios/activityAxios';
import { EXCLUDE_ACCESS_LOG_MENU_IDS } from 'RouteLogger';
import useConfig from 'hooks/useConfig';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const ActivityAccessLog = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { mode } = useConfig();

    const today = nowFormat(t('message.common.text.date.format.date'));
    
    const [searchField, setSearchField] = useState('name');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    const [searchStartDateText, setSearchStartDateText] = useState(today);
    const [searchEndDateText, setSearchEndDateText] = useState(today);

    const [searchUserId, setSearchUserId] = useState();
    const [searchMenuId, setSearchMenuId] = useState();

    // const { data: users } = useQuery({
    //   queryKey: ['user-select'],
    //   queryFn: async () => {
    //     const users = await getSelectUsers();

    //     return users.map(u => ({
    //         id: u.userId,
    //         name: u.userName,
    //     }));
    //   },
    //   staleTime: 0,
    // });
    // const userOptions = users;

    function flattenMenus(menu, result = []) {
      if (!menu) return result;
      if (menu.children?.length === 0) {
        if (!EXCLUDE_ACCESS_LOG_MENU_IDS.has(menu.id)) {
            result.push({
            id: menu.id,
            //   name: menu.name
            name: t(menu.name)
            });
        }
      }
      if (menu.children?.length) {
        menu.children.forEach(child => {
          flattenMenus(child, result);
        });
      }

      return result;
    }
    const menuOptions = flattenMenus(MenuInfo.ROOT);

    const [accessLogs, setAccessLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    
    const [sortModel, setSortModel] = useState(null);

    const excelTitle = t('menu.cmms.management.activity.accessLog');
    const excelTopHeaders = [
        t('message.common.subtitle.activity.accessedAt')
        , t('message.common.subtitle.activity.user') 
        , t('message.common.subtitle.activity.menu')
        , 'URL'
        , 'IP'
    ];
    const fileName = excelTitle+"_"+Date.now();
    // const [excelDatas, setExcelDatas] = useState([]);
    
    let qs = queryString.parse(window.location.search);
    const [searchParam, setSearchParam] = useState({});
    // const [searchParamString, setSearchParamString] = useState('');
    
    let columns = [
        { field: 'accessedAt', headerName: t('message.common.subtitle.activity.accessTime'), sortable:true, width: 200
        , renderCell:(params)=>(params.row?.accessedAt && fromServerFormat(params.row?.accessedAt, {format:t('message.common.text.date.format.datetime')}))
        },
        { field: 'userName', headerName: t('message.common.subtitle.activity.user'), sortable:true, width: 150
        , renderCell:(params)=>(params.row?.userName)
        },
        { field: 'menuName', headerName: t('message.common.subtitle.activity.menu'), sortable:true,  flex:1, mimWidth: 200
        , renderCell:(params)=>(params.row?.menuName && t(params.row?.menuName))
        },
        { field: 'pageUrl', headerName: 'URL', sortable:true, flex:1.5, mimWidth: 250
        , renderCell:(params)=>(params.row?.pageUrl)
        },
        { field: 'ipAddress', headerName: 'IP', sortable:true,  width: 150
        , renderCell:(params)=>(params.row?.ipAddress)
        },
    ];

    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
        setIsLoading(false);

        let searchParamCopy = {...searchParam};
        searchParamCopy.page = (value-1);
        setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
        const searchOrders = searchParam.searchOrder;
        const searchParamCopy = {...searchParam};
        delete searchParamCopy.searchOrder;
        // let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
        // if (searchOrders && searchOrders.length > 0) {
        //     let sortString = '';
        //     searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        //     searchString += sortString;
        // }
        // setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
        const searchParamCopy = {...searchParam};
        let searchOrders = [];
        if (sortModel && sortModel.length > 0) {
            searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
        } else {
            searchOrders.push({sort : "info.name,asc"});
        }
        searchParamCopy.searchOrder = searchOrders;
        setSearchParam(searchParamCopy)
    },[sortModel])
    
    useEffect(()=> {
        if (qs) {
            if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
            if (qs.size) setPageSize(qs.size);
            if (qs.searchField) setSearchField(qs.searchField);
            if (qs.searchStartDateText) setSearchStartDateText(qs.searchStartDateText);
            if (qs.searchEndDateText) setSearchEndDateText(qs.searchEndDateText);
            if (qs.searchUserId) setSearchUserId(qs.searchUserId);
            if (qs.searchMenuId) setSearchMenuId(qs.searchMenuId);

            let searchParamCopy = {...searchParam};
            if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
            if (qs.size) {searchParamCopy.size = qs.size} ;
            if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
            if (qs.searchStartDateText) {searchParamCopy.searchStartDateText = qs.searchStartDateText};
            if (qs.searchEndDateText) {searchParamCopy.searchEndDateText = qs.searchEndDateText};
            if (qs.searchUserId) {searchParamCopy.searchUserId = qs.searchUserId};
            if (qs.searchMenuId) {searchParamCopy.searchMenuId = qs.searchMenuId};
            if (qs.sort && qs.sort.length > 0) {
                let orders = [];
                let sortModel = [];
                if (!Array.isArray(qs.sort)) {
                    orders.push({sort:qs.sort});
                    sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
                } else {
                    (qs.sort).forEach(order=>orders.push({sort:order}));
                    qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
                }
                setSortModel(sortModel)
                searchParamCopy.searchOrder = orders;
            } else {
                delete searchParamCopy.searchOrder
            };
            setSearchParam(searchParamCopy);
        }
        setIsParam(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchStartDateText, qs.searchEndDateText, qs.searchUserId, qs.searchMenuId]);
    
    // 목록
    useEffect(()=> {
        if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam) {
            accessLogList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize, isParam, sortModel]);
        
    const accessLogList = (curPage=currentPage) => {
        isNaN(curPage) && setCurrentPage(0);
        isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
        setCurrentPage(curPage)

        let param = {
            page : curPage,
            size : pageSize,
        };

        if (searchStartDateText) {
            param["startDate"] = searchStartDateText;
        }
        if (searchEndDateText) {
            param["endDate"] = searchEndDateText;
        }
        if (searchUserId) {
            param["userId"] = searchUserId;
        }
        if (searchMenuId) {
            param["menuId"] = searchMenuId;
        }

        if (sortModel && sortModel.length > 0)
            param.sort = sortModel[0].field+","+sortModel[0].sort;
        else
            param.sort = "accessedAt,desc";

        setIsLoading(true);
        getAccessLogs(param).then((data)=>{
            if (data != null) {
                setPageInfo(
                    {
                        size : data.size,
                        totalElements : data.totalElements,
                        totalPages : data.totalPages,
                        number : data.number
                    }
                );
                if(data.content) {
                    setAccessLogs(data.content);
                } else {
                    setCurrentPage(0);
                    setAccessLogs([]);
                }
            } else {
                setPageInfo({
                    size : pageInfo.size,
                    totalElements : 0,
                    totalPages : 0,
                    number : 0
                });
                setAccessLogs([]);
            }
        })
    }
    
    const handleSearch = (event) => {
        event.preventDefault();
        setCurrentPage(0);
        pageInfo.number = 0;
        setPageInfo(pageInfo);
        accessLogList(0);

        let searchParamCopy = {...searchParam};
        searchParamCopy.page = 0;
        if (pageSize) {searchParamCopy.size = pageSize};
        if (searchField) {searchParamCopy.searchField = searchField};
        if (searchStartDateText) {searchParamCopy.searchStartDateText = searchStartDateText};
        if (searchEndDateText) {searchParamCopy.searchEndDateText = searchEndDateText};
        if (searchUserId) {searchParamCopy.searchUserId = searchUserId};
        if (searchMenuId) {searchParamCopy.searchMenuId = searchMenuId};
        setSearchParam(searchParamCopy)
        const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
        navigate("?"+paramString)
    };

    // if (isLoading) {
    return (
    <div className="sub_container">
        <div className='search_section'>
            <div className='selectbox'>
                <div className="desktop_serach">
                <Box component="form">
                    <div>
                    <div>
                        <div style={{display:"inline-block"}}>
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <CustomDatePicker 
                                    name={"searchStartDateText"} 
                                    value={searchStartDateText} 
                                    onChange={(e)=>{setSearchStartDateText(e)}}
                                    className='search_22'
                                />
                            </FormControl>
                            ~
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <CustomDatePicker 
                                    name={"searchEndDateText"} 
                                    value={searchEndDateText} 
                                    onChange={(e)=>{setSearchEndDateText(e)}}
                                    className='search_22'
                                />
                            </FormControl>

                            {menuOptions && 
                            <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <CustomSelect
                                    key={searchMenuId}
                                    label={t('message.common.subtitle.activity.menu')}
                                    labelName={t('message.common.subtitle.activity.menu')}
                                    name={'searchMenuId'}
                                    defaultValue={searchMenuId}
                                    onChange={(e)=>{
                                        setSearchMenuId(e.target.value);
                                    }}
                                    list={menuOptions}
                                />
                            </FormControl>
                            }

                            <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                                <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                            </Button>
                        </div>
                    </div>
                    </div>
                </Box>
                </div>
            </div>
        </div>

        <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
            <DataGridPro
            rows={accessLogs && accessLogs !== undefined ? accessLogs : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
            sx={{
                "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                    display: "none",
                },
                "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
            />

            <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

        </Box>
    </div>
    );
}

export default ActivityAccessLog;